import { Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormGroup, NgForm, NgModel } from '@angular/forms';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { changePasswordStatus, Stage, UserModel } from '../../shared/services/forge-rock.interface';
import { AbstractJourneyComponent } from '../abstract-journey/abstract-journey.component';

@Component({
  selector: 'journey-change-password',
  templateUrl: './journey-change-password.component.html'
})
export class JourneyChangePasswordComponent extends AbstractJourneyComponent implements OnDestroy{
  @Input() buttonText = "Submit";
  @ViewChild('passwordChangeForm', { static: true }) ngForm !: NgForm;
  @ViewChild('ErrModel') errModel !: NgModel;
  @Output() onPasswordChanged= new EventEmitter<any>();


  protected submitted = false;

  private currentPassword !: string;
  private newPassword !:string;
  private passwordControl !: AbstractControl | null;
  private subscriptions:Subscription[] = [];
  protected err !: any;
  protected errorCode !: any;
  protected unknownErrorMessage = "Unknown Error";
  protected errorMessage !: string;
  protected monitorChanges = false;
  private formSubscription !: Subscription;

  private attempts = 0;

  private passwordErrors: any;
  private sentEmail = false; 

  override getTreeName(): string {
    return 'changePassword';
  }

  override ngAfterViewInit():void {
    super.ngAfterViewInit();
    let subscribe = this.OnJourneyStarted.subscribe((val)=>{
      if (val) {
          this.handleLoginFailures();
          subscribe.unsubscribe();
      }
     });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s)=>s?.unsubscribe);
  }

  onSubmit() {
    this.showErrors();
    if(this.ngForm.invalid) {
      return;
    }
    let formdata = this.ngForm.form.value;
    this.currentPassword = formdata.currentPassword?.password;
    this.newPassword = formdata.aNewPassword?.password;
    let userCredentials : UserModel = {} as UserModel;
    userCredentials.password = this.nextStage==Stage.CURRENT_PASSWORD ? this.currentPassword : this.newPassword;
    userCredentials.otpChoice = this.otpChoice;
    userCredentials.validatePassword = this.nextStage==Stage.PASSWORD
   // this.handleResendCode('reject').then((resp) => {
      this.submitted = true
      this.continueJournery(userCredentials).then((nextStage)=>{
        this.submitted = false;
        if (this.nextStage == Stage.PASSWORD && !this.passwordControl) {
          this.monitorPasswordControl();
        }
        if (this.nextStage == Stage.LOGIN) {
            this.onPasswordChanged.emit({status: changePasswordStatus.SUCCESS, loginRedirect: this.loginRedirect})
            this.sentEmail = false;
        }
      },(err)=>{
        this.submitted = false;
      });
    //});
  }

  private continueJournery(credentials:UserModel):Promise<any> {
     let currentStage = this.nextStage;
     return this.nextStageInJourney(credentials).then((nextStage)=>{
 
           if (currentStage == Stage.PASSWORD) {
              let violations = this.checkForPolicyViolations(currentStage,undefined);
              this.passwordControl?.setErrors(violations);
              this.passwordErrors = violations;
              if (violations == null && credentials.validatePassword) {
                credentials.validatePassword = false;
                return this.continueJournery(credentials);
              }
          }
 
      return nextStage;
    });
  }

  private monitorPasswordControl() {
    let controls = this.ngForm.controls["aNewPassword"] as FormGroup;
    this.passwordControl = controls?.get('newPassword');
    if (this.passwordControl) {
        this.subscriptions.push(this.passwordControl.valueChanges?.subscribe((val)=>{
          if (val!=this.newPassword) {
            this.passwordErrors = null;
          }
        }));
    }
  }

    protected handleLoginFailures() {
      this.subscriptions.push(this.FRService.OnLoginFailure.subscribe((err:any)=>{
        this.errorCode = err && err.code ? err.code : undefined;
        this.errorMessage = this.errorCode && err.message ? err.message : environment.common.errorMessages.loginFailureUnknown; 
        if (this.errorCode) {
            ++this.attempts;
            if (this.attempts > environment.common.constants.allowedCurrentPasswordEntries) {
              this.endSession(true);
              this.onPasswordChanged.emit({status: changePasswordStatus.CURRENT_PASSWORD_FAILURE, loginRedirect: this.loginRedirect})
            } else {
              this.monitorChanges = true;
              this.formSubscription = this.ngForm.form.valueChanges.subscribe((val:any)=>{
                if (val && !this.monitorChanges) {
                  this.formSubscription.unsubscribe();
                  this.errorCode = undefined;
                }
                this.monitorChanges = false;
              });
            }
        }
      }));
    }

}
